<section
  class="banner"
  role="status"
  aria-live="polite"
  data-testid="sso-welcome-banner">
  <mat-icon class="banner__icon">check_circle_outline</mat-icon>
  <div class="banner__text">
    <div class="banner__title">
      {{ 'GNR_SSO_WELCOME_TITLE' | translate: [] : titleFallback }}
    </div>
    <div class="banner__message">
      {{
        'GNR_SSO_WELCOME_MSG'
          | translate: [company(), roleLabel()] : messageFallback()
      }}
    </div>
  </div>
  <button
    type="button"
    mat-icon-button
    class="banner__close"
    [attr.aria-label]="'CMD_CLOSE' | translate: [] : 'Close'"
    data-testid="sso-welcome-close"
    (click)="closed.emit()">
    <mat-icon>close</mat-icon>
  </button>
</section>
